<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="样式同步" name="1">
        <div class="mb8">
          <el-checkbox v-model="asyncStatus">同步默认状态</el-checkbox>
        </div>
      </el-collapse-item>
      <el-collapse-item title="高级设置" name="2">
        <div class="mb8 verticallyCenter">
          <el-checkbox v-model="hasChildOnlyOpen">节点仅用于折叠和展开</el-checkbox>
          <i class="tips-btn icon-portal-info2" @click="explainDialog=true"></i>
        </div>
        <div v-if="notNavMenuType" class="verticallyCenter">
          <el-checkbox v-model="defaultExpand">进入页面默认展开选中节点</el-checkbox>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        如果在一个不是最低层级的分类级别上配置了跳转链接或数据展示，开启后不会跳转或切换数据
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
      explainDialog: false
    }
  },
  props: {
    options: {
      type: Object
    }
  },
  computed: {
    asyncStatus: {
      get() {
        this.checkAndSetPrimaryVal(this.options, "asyncStatus", "asyncStatus", true)
        return this.options.asyncStatus
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "asyncStatus", false)
      }
    },
    hasChildOnlyOpen: {
      get() {
        return this.options.hasChildOnlyOpen || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hasChildOnlyOpen", false)
      }
    },
    defaultExpand: {
      get() {
        this.checkAndSetPrimaryVal(this.options, "defaultExpand", "defaultExpand", true)
        return this.options.defaultExpand
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "defaultExpand", false)
      }
    },
    notNavMenuType() {
      const isListPage = this.$store.state[this.request_prefix].type === "listPage"
      const notMenuSubPage = this.$store.state.states.getDataPageIds.name !== "导航菜单"
      return isListPage && notMenuSubPage
    }
  }
}
</script>
